function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 421.599,
    height: 421.587,
    viewBox: "0 0 111.548 111.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      strokeWidth: 0.26458332
    },
    d: "M-92.648 224.935c0-7.692 6.252-13.944 13.944-13.944h34.859c7.691 0 13.943 6.252 13.943 13.944v41.828h1.744c10.589 0 19.172 8.583 19.172 19.172v20.84a5.216 5.216 0 0 0 5.228 5.229 5.216 5.216 0 0 0 5.228-5.228v-52.954c-6.014-1.548-10.456-7.014-10.456-13.507v-13.943l-6.972-6.972a4.942 4.942 0 0 1 0-6.972 4.942 4.942 0 0 1 6.972 0l16.84 16.84a13.948 13.948 0 0 1 4.075 9.87v67.638c0 8.67-7.014 15.687-15.687 15.687-8.673 0-15.687-7.014-15.687-15.687v-20.841c0-4.816-3.9-8.716-8.716-8.716h-1.743v31.372a6.964 6.964 0 0 1 6.971 6.972 6.963 6.963 0 0 1-6.971 6.971h-62.744a6.964 6.964 0 0 1-6.971-6.971 6.963 6.963 0 0 1 6.971-6.972zm13.944 3.484v20.916a3.494 3.494 0 0 0 3.484 3.484h27.888a3.494 3.494 0 0 0 3.484-3.484v-20.916a3.494 3.494 0 0 0-3.484-3.484H-75.22a3.494 3.494 0 0 0-3.484 3.484z",
    className: "cls-1",
    transform: "translate(99.62 -210.99)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillRule: "evenodd",
      strokeWidth: 0.26458332
    },
    d: "M-19.215 226.462a.347.347 0 0 0-.572.328c.059.28-.034.621-.2 1.01-.297.688-.84 1.495-1.461 2.36-.963 1.345-2.114 2.818-2.884 4.186-.543.966-.89 1.884-.89 2.675a5.777 5.777 0 0 0 5.774 5.773 5.777 5.777 0 0 0 5.773-5.773c0-1.278-.7-3.077-1.63-4.836-1.375-2.599-3.233-5.115-3.91-5.723z",
    className: "cls-2",
    transform: "translate(99.62 -210.99)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLogo);
export default __webpack_public_path__ + "static/media/gas_logo.c46d4d0e6e2821e728e0e0ea1ee9d023.svg";
export { ForwardRef as ReactComponent };